@use "../styles/variables" as *;

.toast-provider-container {
  position: relative;

  .toasts-container {
    position: fixed;
    z-index: $z_index_10000;
    top: calc($header-height + var(--size-xs));
    right: var(--size-sm);

    .toast-title {
      font-weight: bold;
    }
  }
}
